import React, { useEffect } from 'react'
import { Container, Row, Col, Card, Accordion, useAccordionButton } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import SubMenuCandidateSelection from '../../components/menus/SubMenuCandidateSelection'
import { getRequestsSentByCandidate, removePrecandidate } from '../../actions/selectionsActions'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { getCandidate } from '../../actions/candidatesActions'

export default function RequestsSent() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {loading, selections, resultselection} = useSelector(state => state.selections)
    const {levels, subjects} = useSelector(state => state.miscellaneous)
    const {candidate} = useSelector(state=>state.candidates)

    const capitalizeFirstCharacter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        } else {
            return ''
        }
    }

    const handleCancelRequest = (selection) =>  {
        Swal.fire({
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            text: t('selection.candidateCancelRequestQuestion'),
            cancelButtonText: t('global.cancel'),
            confirmButtonText: t('global.yes')
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(removePrecandidate(selection?._id, candidate?._id))
            }
        })
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getRequestsSentByCandidate(client?.id))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
            dispatch(getCandidate(client?.id))
        }
    },[dispatch, t, client])

    useEffect(() => {
        if (resultselection && resultselection === "removePrecandidateSuccess") {
            Swal.fire({
                showConfirmButton: true,
                showDenyButton: false,
                confirmButtonText: t('global.great'),
                icon: 'success',
                text: t('selection.' + resultselection)
            })
            dispatch({type: 'SELECTION_RESET_RESULT'})
        }
    }, [resultselection, dispatch, client, navigate])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-5'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Procesos" />
                        <h1 className='ms-2 m-0'>{t('menus.candidateProcesses')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-5 pt-5'>
                                <Row className='mb-5'>
                                    <Col>
                                        <h3>{t('menus.completedprocesses')}</h3>
                                    </Col>
                                </Row>
                                <SubMenuCandidateSelection section="requestsSent"/>
                                {
                                    loading
                                    ?
                                        <div className='d-flex justify-content-center'>
                                            <span className="indicator-label">
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </div>
                                    :
                                        selections?.length > 0
                                        ?
                                        <>
                                            <Row className="d-none d-lg-block mt-3 border-bottom fw-bold">
                                                <Col className='d-flex'>
                                                    <div style={{width: "40%"}} className='py-2 ps-5'>{t("selection.title")}</div>
                                                    <div style={{width: "15%"}} className='py-2'>{t("selection.specialty")}</div>
                                                    <div style={{width: "20%"}} className='py-2'>{t("selection.subject")}</div>
                                                    <div style={{width: "15%"}} className='py-2'>{t("selection.school")}</div>
                                                    <div style={{width: "10%"}} className='py-2 bg-grey text-center'>{t("global.actions")}</div>
                                                </Col>
                                            </Row>
                                            <Accordion>
                                                {selections?.map((selection, selectionIndex) => (
                                                    <Card key={selectionIndex} className='my-2'>
                                                        <Card.Header className='px-0'>
                                                            <Row className='w-100 mx-0 px-0'>
                                                                <Col className='d-flex align-items-center px-0 mx-0'>
                                                                    <div style={{width: "5%"}} className='py-2 d-flex justify-content-center'><AccordionToggle eventKey={selectionIndex}><i className ='fas fa-chevron-right cursor d-block'></i></AccordionToggle></div>
                                                                    <div className='py-2' style={{width: window.innerWidth < 768 ? "85%" : "35%"}}>{selection.title}</div>
                                                                    <div style={{width: "15%"}} className='py-2 d-none d-lg-block'>{capitalizeFirstCharacter(levels?.find(l => l.id === selection.specialty)?.label)}</div>
                                                                    <div style={{width: "20%"}} className='py-2 d-none d-lg-block'>{t("subjects." + subjects?.find(s => s.id === selection.subject)?.label)}</div>
                                                                    <div style={{width: "15%"}} className='py-2 d-none d-lg-block'>{selection.school.name}</div>
                                                                    <div style={{width: "10%"}} className='py-2 d-flex justify-content-center align-items-center'>
                                                                        <Link to={`/candidate/process/${selection._id}`} className='me-1'><img src='/images/eye.svg' alt='Ver'/></Link>
                                                                        <img src='/images/trash.svg' alt='Cancelar' className='ms-1 cursor' onClick={() => handleCancelRequest(selection)}/>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Card.Header>
                                                        <Accordion.Collapse eventKey={selectionIndex}>
                                                            <Card.Body>
                                                                <div>
                                                                    <h5 className='fw-bold'>{t("selection.offerSummary")}</h5>
                                                                    <Row className='bg-grey'>
                                                                        <Col xs={6} className='py-2 pe-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("users.province")}
                                                                                <small>{provinces?.find(p => p.value === selection.school.province)?.label}</small>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={6} className='py-2 ps-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("selection.contractType")}
                                                                                <small>
                                                                                    {
                                                                                        selection?.fixedDiscontinuous
                                                                                        ?
                                                                                            t('selection.fixedDiscontinuous')
                                                                                        :
                                                                                            t('profile.candidate.'+selection?.contractType)
                                                                                    }
                                                                                </small>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col xs={6} className='py-2 pe-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("users.town")}
                                                                                <small>{towns?.find(p => p.value === selection.school.town)?.label}</small>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={6} className='py-2 ps-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("profile.candidate.idealPosition.workDay.label")}
                                                                                <small>{t("profile.candidate.idealPosition.workDay." + selection.workdayType)}</small>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='bg-grey'>
                                                                        <Col xs={6} className='py-2 pe-5'>
                                                                            <div className='d-flex justify-content-between'>
                                                                                {t("selection.shortIncorporationDate")}
                                                                                <small>{`${String(new Date(selection.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selection.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selection.incorporationDate).getFullYear()}`}</small>
                                                                            </div>
                                                                        </Col>
                                                                        {
                                                                            selection.distance !== null &&
                                                                            <Col xs={12} md={6} className='d-flex justify-content-between ps-5'>
                                                                                <div className='title'>{t("selection.distance")}</div>
                                                                                <div className='data'>{selection.distance !== 0 && selection.distance !== "0" ? `${Math.trunc(Number(selection.distance))} km` : t("selection.zeroDistance")}</div>
                                                                            </Col>
                                                                        }
                                                                    </Row>
                                                                </div>
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                ))}
                                            </Accordion>
                                        </>
                                        :
                                        <div className='text-center'>{t("selection.thereisnotprocess")}</div>

                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

function AccordionToggle({children, eventKey, callback}) {
    const handleAccordionToggle = useAccordionButton(
        eventKey,
        () => callback && callback(eventKey),
    )

    return (
        <span onClick={handleAccordionToggle} className='cursor'>{children}</span>
    )
}